import React, {useState, useEffect} from "react";
import logo from '../../shared/assets/images/logoHeader.svg';
import {Drawer, Menu} from '@mantine/core';
import S from './Header.module.scss';
import {useDisclosure} from "@mantine/hooks";
import {HeaderMobile} from "./HeaderMobile";
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import {ModalWindow} from "../modal";
import {useLocation, useParams} from "react-router-dom";

export const Header = () => {
  const scrollToSection = useScrollToSection();
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const { titleUrl } = useParams();
  const location = useLocation();
  const isEventPage = location.pathname.includes('/event/');

  const [openedMenu, {open: openMenu, close: closeMenu}] = useDisclosure(false);
  const [openedModal, {open: openModal, close: closeModal}] = useDisclosure(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`${S.header} ${isScrolled ? S.headerScrolled : ''}`}>
      <div className={S.content}>
        {/* Кнопка бургера */}
        <button
            className={`${S.burger} ${openedMenu ? S.burgerActive : ''}`}
            onClick={openMenu}
            aria-label="Меню"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={S.logoButton}>
          <div className={S.picture} onClick={() => scrollToSection('announcements')}>
            <img src={logo} alt="Logo"/>
          </div>

          {/* Десктопное меню */}
          <div className={`${S.menuButton} ${openedMenu ? S.menuOpen : ''}`}>
            <div className={S.menuTarget} onClick={() => scrollToSection('announcements')}>Мероприятия</div>
            <div className={S.menuTarget} onClick={() => scrollToSection('about')}>О нас</div>
            <div className={S.menuTarget} onClick={() => scrollToSection('archive')}>Архив</div>
            <div className={S.menuTarget} onClick={() => scrollToSection('partners')}>Партнёры</div>
            <div className={S.menuTarget} onClick={() => scrollToSection('contacts')}>Контакты</div>
          </div>

          <div className={`${S.menuButtonLaptop} ${openedMenu ? S.menuOpen : ''}`}>
            <div className={S.menuTarget} onClick={() => scrollToSection('announcements')}>Мероприятия</div>
            <div className={S.menuTarget} onClick={() => scrollToSection('about')}>О нас</div>
            <Menu width={200} position="bottom-start">
              <Menu.Target>
                <div className={S.menu}>•••</div>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item className={S.menuItem} onClick={() => scrollToSection('archive')}>Архив</Menu.Item>
                <Menu.Item className={S.menuItem} onClick={() => scrollToSection('partners')}>Партнёры</Menu.Item>
                <Menu.Item className={S.menuItem} onClick={() => scrollToSection('contacts')}>Контакты</Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </div>
        </div>

        <Drawer opened={openedMenu} onClose={closeMenu} size={300} withCloseButton={false} styles={{
          body: {
            padding: 0,
          },
          root: {
            zIndex: 304,
          },
          overlay: {
            zIndex: 303,
          },
          inner: {
            zIndex: 304,
          }
        }}>
          <HeaderMobile onClose={closeMenu}/>
        </Drawer>

        <div className={S.divTelephone}>
          <a href="tel:+79220197166" className={S.telephone}>+7 (922) 019-71-66</a>
          <button className={S.registration} onClick={openModal}>РЕГИСТРАЦИЯ</button>
        </div>
      </div>
      <ModalWindow
          opened={openedModal}
          close={closeModal}
          event={(isEventPage && titleUrl === 'digitalization-industry') ? 1 : (isEventPage && titleUrl === 'transport-logistics') ? 5 : undefined}
      />
    </div>
  );
}